import * as types from './mutation_types';

const actions = {
  updateErr: ({ commit }, payload) => {
    commit(types.UPDATE_ERR, payload);
  },
  signedIn: ({ commit }, payload) => {
    commit(types.SIGNED_IN, payload);
  },
  updateStorageList: ({ commit }, payload) => {
    commit(types.UPDATE_LIST, payload);
  },
  updateFileInfo: ({ commit }, payload) => {
    console.log(payload);
    commit(types.UPDATE_FILE_INFO, payload);
  },
};

export default actions;
